import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';

import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import LifeHackBannerView from '@/js/common/components/lifeHackBanner/LifeHackBanner';
import imageProxy from '@/js/common/Domain/Service/imageProxy';
import checkLotteryService from '@/js/common/Domain/Service/checkLottery';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import ecommerceService from '@/js/common/Domain/Service/ecommerce';
import LotteryBannerView from '@/js/desktop/components/search/lotteryBannerSerp/LotteryBanner';
import TourHunterSubscribeView from '@/js/desktop/components/search/tourHunterSubscribe/TourHunterSubscribe';
import ThFavoritesView from '@/js/desktop/components/thFavorites/thFavorites';

import hotelTemplate from './searchPageHotel/hotelTemplate.html';
import IsExclusiveBlock from '@ve/components/hotel/isExclusiveBlock/desktop/isExclusiveBlock.vue';
import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.css';
import '@/css/desktop/tooltip.scss';

import componentsBannerTemplate
    from '@view/desktop/travelata/layout/parts/search/search__tour-usually-includes-js.phtml';

import '@/js/desktop/components/search/useFilters/styles/useFilters.css';
import '@/js/desktop/components/search/useFilters/styles/useFiltersBnr.scss';
import filterBannerTemplate from '@/js/desktop/components/search/useFilters/search__use-filters-banner-js.phtml';

import appBannerTemplate from '@/js/desktop/components/search/appBanner';
import genleadBannerTemplate from '@view/desktop/travelata/layout/parts/search/search__regions-msg.phtml';

import CashbackHotelCardBannerView from '@/js/desktop/components/cashbackHotelCardBanner/cashbackHotelCardBanner';
import CashbackPartialPaymentTourBannerView
    from '@/js/desktop/components/partialPayment/cashbackPartialPaymentTourBanner/cashbackPartialPaymentTourBanner';
import PartialPaymentTourBannerView
    from '@/js/desktop/components/partialPayment/partialPaymentTourBanner/partialPaymentTourBanner';

import paylateBnr from '@/js/desktop/components/search/paylate/paylateBnr/paylateBnr';
import { DESKTOP_SEARCH_PAGE_BANNER_STEP } from '@/js/common/Constants/bannerSteps';
import trackImageErrors from '@/js/common/Domain/Service/trackImageErrors';

import checkTourCashbackAvailable from '@/js/common/Domain/Service/checkTourCashbackAvailable';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import '@/css/common/components/warranted-icon.scss';

const SearchPageHotelViewModel = Backbone.Epoxy.Model.extend({
    defaults: {
        hotelIndex: null,
        componentsOrder: null,
        regionType: null,
        regionWithOffices: null,
        searchPageModel: null,
        subscribeBannerView: null,
        subscribeBanner: null,
        lifeHackBannerEmailWasSend: false,
        hidePartialBanner: false,
    },
    computeds: {
        filterBanner: {
            deps: ['hotelIndex', 'componentsOrder'],
            get(hotelIndex, componentsOrder) {
                return this.checkBannerPosition(hotelIndex, componentsOrder, 'filterBanner') ? filterBannerTemplate({ hotelIndex }) : '';
            },
        },
        lotteryBanner: {
            deps: ['hotelIndex', 'componentsOrder'],
            get(hotelIndex, componentsOrder) {
                let $lotteryBanner = '';

                if (this.checkBannerPosition(hotelIndex, componentsOrder, 'lottery')) {
                    $lotteryBanner = (new LotteryBannerView()).$el;
                }

                return $lotteryBanner;
            },
        },
        genleadBanner: {
            deps: ['hotelIndex', 'componentsOrder', 'regionType', 'regionWithOffices'],
            get(hotelIndex, componentsOrder, regionType, regionWithOffices) {
                const subscribeBanner = this.checkBannerPosition(hotelIndex, componentsOrder, 'subscribe');

                return (subscribeBanner && regionType === 'region' && regionWithOffices && document.location.pathname !== '/search') ? genleadBannerTemplate() : '';
            },
        },
        componentsBanner: {
            deps: ['hotelIndex', 'componentsOrder'],
            get(hotelIndex, componentsOrder) {
                return this.checkBannerPosition(hotelIndex, componentsOrder, 'tourIncludes') ? componentsBannerTemplate({ hotelIndex }) : '';
            },
        },
        appBanner: {
            deps: ['hotelIndex', 'componentsOrder'],
            get(hotelIndex, componentsOrder) {
                return this.checkBannerPosition(hotelIndex, componentsOrder, 'appBanner') ? appBannerTemplate() : '';
            },
        },
        lifeHackBanner: {
            deps: ['hotelIndex', 'componentsOrder'],
            get(hotelIndex, componentsOrder) {
                let $banner = '';
                if (this.checkBannerPosition(hotelIndex, componentsOrder, 'lifeHackBanner')) {
                    $banner = (new LifeHackBannerView({
                        model: this,
                    })).$el;
                }
                return $banner;
            },
        },
        paylateBnr: {
            deps: ['hotelIndex', 'componentsOrder'],
            get(hotelIndex, componentsOrder) {
                let $banner = '';

                if (this.checkBannerPosition(hotelIndex, componentsOrder, 'paylateBnr')) {
                    $banner = paylateBnr(hotelIndex);
                }

                return $banner;
            },
        },
        conditionalBanner: {
            deps: ['subscribeBanner', 'genleadBanner'],
            get: (subscribeBanner, genleadBanner) => (subscribeBanner && !genleadBanner ? subscribeBanner : genleadBanner),
        },
    },
    calculateSybscribeBanner() {
        let $subscribeBanner = '';
        let subscribeBannerView;
        const hotelIndex = this.get('hotelIndex');
        const componentsOrder = this.get('componentsOrder');
        const searchPageModel = this.get('searchPageModel');

        if (this.checkBannerPosition(hotelIndex, componentsOrder, 'subscribe')) {
            subscribeBannerView = new TourHunterSubscribeView({
                searchPageModel,
                searchFormViewModel: this.searchFormViewModel,
                hotelIndex,
            });
            $subscribeBanner = this.subscribeBannerTemplate || subscribeBannerView.$el;
        }

        this.set('subscribeBannerView', subscribeBannerView);
        this.set('subscribeBanner', $subscribeBanner);
    },
    checkBannerPosition(index, componentsOrder, componentName) {
        const step = DESKTOP_SEARCH_PAGE_BANNER_STEP;
        const componentsLength = step * componentsOrder.length;
        let elLength;
        let componentsOrderElName;

        componentsOrderElName = componentsOrder[((index - step + 1) / step) % componentsOrder.length];
        if (_.isArray(componentsOrderElName)) {
            elLength = componentsOrderElName.length;
            const elIndex = parseInt((index / componentsLength)) % elLength;
            componentsOrderElName = componentsOrderElName[elIndex];
        }
        return componentsOrderElName === componentName;
    },
    initModelEvents() {
        this.on('change:componentsOrder', $.proxy(this.calculateSybscribeBanner, this));
    },
    initialize(options) {
        this.searchFormViewModel = options.searchFormViewModel;
        this.subscribeBannerTemplate = options.subscribeBannerTemplate;
        this.initModelEvents();
    },
});

const SearchPageHotelView = Backbone.Epoxy.View.extend({
    el: '<div class="serpHotelCard"></div>',
    hotelTemplate,
    data: null,
    template: null,
    bindings: {
        '.serpHotelCard': 'classes:{isExclusive: isExclusive}',
        '.js-componentsBanner': 'html: componentsBanner',
        '.js-filterBanner': 'html: filterBanner',
        '.js-lotteryBanner': 'html: lotteryBanner',
        '.js-conditionalBanner': 'html: conditionalBanner',
        '.js-appBanner': 'html: appBanner',
        '.js-lifeHackBanner': 'html: lifeHackBanner',
        '.js-paylateBnr': 'html: paylateBnr',
    },
    events: {
        'click .goToHotelWithId': 'goToHotelWithId',
        'click .serpHotelCard__container': 'setInCookieMinPrice',
        'click .goToHotel': 'goToHotel',
        'mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange, .cashbackPartialPaymentTourBanner-cashbackSection__link)': 'hotelClick',
        'click .regionsMsg__btn span': 'openGeneralLead',
        'click .thSubscribeBtn': 'submitTourHunter',
        'click .js-th-button': 'submitTourHunter',
        'submit .js-th-form': 'submitTourHunter',
        'click .banner-close': 'closeBanner',
    },
    closeBanner(e) {
        const { currentTarget } = e;
        const banerName = $(currentTarget).data('banner');
        const bannerPosition = $(currentTarget).data('index') + 1;
        const parent = currentTarget.parentElement;

        if (!parent) return;

        window.dataLayer.push({
            event: 'selectContent',
            selectContent:
                {
                    prop: [
                        { type: 'engageBanner', value: banerName },
                    ],
                    prop2: [
                        { type: 'position', value: bannerPosition },
                    ],
                },
        });

        $(parent).remove();
    },

    hotelClick(e) {
        this.dataLayerEvents();
        this.hrefUrl(e);
    },

    async openGeneralLead() {
        const tourCriteria = this.collectionView.model.get('searchData');

        const { default: generalLead } = await import(/* webpackChunkName: "general-lead" */ '@/js/desktop/components/generalLead/general-lead.js');

        generalLead.open(tourCriteria ? {
            tourCriteria,
        } : {});
    },
    setInCookieMinPrice() {
        $.cookie('hotelMinPrice', this.model.get('priceWithOilTax'), {
            expires: 1 / 24 / 60 / 3,
            path: '/',
            domain: 'all',
        });
    },

    generateImagesHtml({ cover, photos }) {
        let html = '';
        const images = [].concat(
            cover || [],
            photos || [],
        );

        if (images?.length) {
            _.each(images, (photo) => {
                html += `<li><a href="#" data-src="${imageProxy(photo, {
                    width: 300,
                    height: 220,
                })}"></a></li>`;
            });

            const randomPhoto = images[Math.round(Math.random() * (images.length - 1))];
            html += `<li class="lastPhotoLink"><a class="img" href="#" data-src="${imageProxy(randomPhoto, {
                width: 300,
                height: 220,
            })}"></a><a href="#" class="btn">Смотреть все фото</a></li>`;
        }

        return html;
    },
    renderPhotos() {
        let imagesHtml = this.model.get('imagesHtml');
        const $modelElement = this.model.$element;
        const $imagesPlace = $('.imagesHtml', $modelElement);
        const $carousel = $('.js-images-carousel', $modelElement);

        if (!imagesHtml) {
            imagesHtml = this.generateImagesHtml({
                cover: this.model.get('cover'),
                photos: this.model.get('photos'),
            });
            this.model.set('imagesHtml', imagesHtml);
        }

        if (imagesHtml) {
            if ($imagesPlace.length) {
                $imagesPlace.html(imagesHtml);
            }

            if (_.isObject($carousel.data('jcarousel'))) {
                $carousel.jcarousel('reload', {
                    animation: 'fast',
                });
                $carousel.jcarousel('scroll', 0, false);
            }
        }
    },

    selectTemplate() {
        return this.template;
    },
    componentsList() {
        const enableLottery = checkLotteryService();
        const tourhunterAlreadySubscribed = this.collectionView.model.get('tourhunterAlreadySubscribed');
        let componentsOrder = [
            'filterBanner',
            'paylateBnr',
            'subscribe',
            'lottery',
            'tourIncludes',
            'lifeHackBanner',
            'appBanner',
        ];

        componentsOrder = enableLottery ? componentsOrder : _.without(componentsOrder, 'lottery');
        componentsOrder = !tourhunterAlreadySubscribed ? componentsOrder : _.without(componentsOrder, 'subscribe');

        return componentsOrder;
    },
    render() {
        let template;
        const self = this;
        const data = this.model.toJSON({ computed: true });
        const hotelIndex = self.collectionView.collection.indexOf(self.model);

        if (self.collectionView) {
            template = this.selectTemplate();
        }

        data.originalHotelObject = this.model;

        self.viewModel = new SearchPageHotelViewModel({
            hotelIndex,
            componentsOrder: self.componentsList(),
            regionType: self.collectionView.model.get('regionType'),
            regionWithOffices: self.collectionView.model.get('regionWithOffices'),
            searchPageModel: self.collectionView.model,
            searchFormViewModel: self.searchFormViewModel,
            subscribeBannerTemplate: self.subscribeBannerTemplate || null,
        });
        data.hotelIndex = hotelIndex;

        if (this.hotelMapView) {
            this.hotelMapView.reRender({
                data,
                $el: this.$el,
                parentModel: this.model,
                collectionView: this.collectionView,
            });
        } else {
            this.$el.html(template(data));
        }

        setTimeout(() => {
            self.applyBindings();
            self.viewModel.calculateSybscribeBanner();
        }, 0);

        this.data = data;

        this.initCarousel();
        this.renderPhotos();
        this.initSubViews();
        this.initVueComponents();
        this.showBottomBanner();
    },

    showBottomBanner() {
        const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();
        const hasTourCashbackAvailable = checkTourCashbackAvailable(this.model.get('tourProducts'));

        const isCashbackAvailable = window?.appConfig?.cashbackAvailable
            && hasTourCashbackAvailable;

        if (isCashbackAvailable) {
            if (isVisiblePartialPayment) {
                this.initCashbackPartialPaymentBanner();
                return;
            }

            this.initCashbackBanner();
            return;
        }

        if (isVisiblePartialPayment) {
            this.initPartialPaymentBanner();
        }
    },

    getPartialPaymentData() {
        const tourProducts = this.model.get('tourProducts');
        const tourProduct = tourProducts?.at(0);

        const isVisible = !!tourProduct.get('firstPaymentDefinition')?.id;
        const countryName = this.model.get('country').get('name');

        return {
            isVisible,
            countryName,
            tourProducts,
        };
    },

    initPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('partialPayment');

        new PartialPaymentTourBannerView({
            el: this.$el.find('.partialPayment__banner'),
            countryName,
            tourProducts,
        });
    },

    initCashbackPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('cashbackPartialPayment');

        new CashbackPartialPaymentTourBannerView({
            el: this.$el.find('.cashbackPartialPayment__banner'),
            countryName,
            tourProducts,
        });
    },

    initCashbackBanner() {
        //Serp tours
        new CashbackHotelCardBannerView({
            el: $('.serpHotelCard__container', this.$el),
            productType: 'tour',
        });
    },

    initSubViews() {
        new ThFavoritesView({
            model: this.model,
            searchPageModel: this.collectionView.model,
            el: $('.addToFavorites', this.$el),
        });

        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    },
    initVueComponents() {
        const isExclusive = this.model.get('isExclusive');
        if (isExclusive) {
            this.IsExclusiveBlockVueComponent = new IsExclusiveBlock({
                el: $('.js-serpHotelCard__isExclusive', this.$el).get(0),
                propsData: {
                    isExclusive,
                },
            });
        }
    },
    initCarousel() {
        $('.js-images-carousel', this.$el).jcarousel({
            list: '.list',
            items: 'li',
            wrap: 'both',
            vertical: false,
        }).on('jcarousel:visiblein', 'li', function () {
            const $element = $('a:not(.btn)', this);
            const imageUrl = $element.data('src');

            $element.css('background-image', `url("${imageUrl}")`);
            trackImageErrors([imageUrl]);
        });

        $('.js-images-carousel-control-prev', this.$el).jcarouselControl({
            target: '-=1',
        });

        $('.js-images-carousel-control-next', this.$el).jcarouselControl({
            target: '+=1',
        });
    },
    reRender(model) {
        this.render();
    },

    initSubscribes() {
        const self = this;

        this.model.on('change:minPrice', $.proxy(this.reRender, this));
        this.model.on('change:tourProducts', $.proxy(this.reRender, this));

        checkLotteryService(() => {
            self.viewModel.set('componentsOrder', self.componentsList());
        });

        if (this.collectionView) {
            this.collectionView.model.on('change:tourhunterAlreadySubscribed', $.proxy(this.updateSubscribes, this));
            this.collectionView.model.on('change:regionType', (model, value) => {
                self.viewModel.set('regionType', value);
            });
            this.collectionView.model.on('change:regionWithOffices', (model, value) => {
                self.viewModel.set('regionWithOffices', value);
            });
        }
    },
    updateSubscribes(model, value, context) {
        const subscribeBannerView = this.viewModel.get('subscribeBannerView');
        const $tourhunterBlock = this.viewModel.get('subscribeBanner');
        const self = this;

        if (!$tourhunterBlock || !subscribeBannerView || !subscribeBannerView.currentSubscribeBanner()) {
            self.viewModel.set('componentsOrder', self.componentsList());
        }
    },
    getComponentsData() {
        const self = this;
        const countries = self.viewModel.get('searchPageModel').get('searchData').get('countries');

        checkLotteryService(() => {
            self.viewModel.set('componentsOrder', self.componentsList());
        });
    },
    searchFormViewModel: null,
    initialize(options) {
        this.collectionView = options.collectionView;
        this.dataLayerAnalytics = options.collectionView.dataLayerAnalytics;
        this.template = options.template ? options.template : this.hotelTemplate;
        this.hotelMapView = options.hotelMapView;
        this.model.$element = this.$el;

        this.render();
        this.initSubscribes();
        this.getComponentsData();
    },
    hrefUrl(event) {
        const identity = $(event.currentTarget).data('identity');
        const urlParams = toRouterHotelHydrator({
            tourCriteria: this.model.get('tourProducts').at(0).get('tourCriteria'),
            similar: !!this.model.get('similar'),
            isExclusive: this.collectionView.model.filterCriteria.get('isExclusive'),
        });
        const hotelUrl = this.model.get('url');
        const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
        const $target = $(event.currentTarget);

        if (typeof identity !== 'undefined') {
            urlParams.identity = identity;
            if (event.which == 2) {
                gaAsync(() => {
                    ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', { nonInteraction: 1 });
                });
            }
        } else if (event.which == 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
            gaAsync(() => {
                ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', { nonInteraction: 1 });
            });
        }
        if ($target.hasClass('distance')) {
            urlParams.toMap = true;
        }
        urlParams.sid = searchSessionService.getSearchId();
        $(event.currentTarget).attr('href', `${hotelUrl}#?${$.param(urlParams)}`);
        $(event.currentTarget).attr('target', target);
        ls.set('isAbsent', false);
    },
    goToHotelWithId(event, param2, param3) {
        const identity = $(event.currentTarget).data('identity');
        const tourProduct = this.model.get('tourProducts').findWhere({ id: identity });
        const tourCriteria = typeof (tourProduct) === 'undefined' ? null : tourProduct.get('tourCriteria');

        if (tourCriteria !== null) {
            const urlParams = toRouterHotelHydrator({
                tourCriteria,
                isExclusive: this.collectionView.model.filterCriteria.get('isExclusive'),
                identity,
                similar: !!this.model.get('similar'),
            });
            const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
            const hotelUrl = this.model.get('url');

            urlParams.sid = searchSessionService.getSearchId();
            window.open(`${hotelUrl}#?${$.param(urlParams)}`, target);
            ls.set('isAbsent', false);
        }
        return false;
    },
    goToHotel(event) {
        const tourCriteria = this.model.get('tourProducts').at(0).get('tourCriteria');
        const urlParams = toRouterHotelHydrator({
            tourCriteria,
            similar: !!this.model.get('similar'),
            isExclusive: this.collectionView.model.filterCriteria.get('isExclusive'),
        });
        const $target = $(event.currentTarget);
        const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
        const hotelUrl = this.model.get('url');

        if ($target.hasClass('distance')) {
            urlParams.toMap = true;
        }
        if ($target.hasClass('hotel-reviews')) {
            urlParams.toReviews = true;
        }
        urlParams.sid = searchSessionService.getSearchId();
        window.open(`${hotelUrl}#?${$.param(urlParams)}`, target);
        ls.set('isAbsent', false);
        return false;
    },
    offerClick() {
        ecommerceService.productClick({
            product: this.model,
            category: 'tour',
            pageType: 'serpTour',
            collection: this.collectionView.collection,
            departureCityName: this.collectionView.model.get('searchData').get('departureCity').get('name'),
        });
    },
    dataLayerEvents() {
        if (!this.dataLayerAnalytics) {
            return;
        }
        this.dataLayerAnalytics.searchClickEvent(this);
    },
});

export default SearchPageHotelView;
